// JavaScript Document

// Struttura dell'oggetto per mappare le vecchie configurazioni sul nuovo configuratore:
//    mapping[productId] = {
//       modelId: wordpress_pen_model_id,
//       propertyPicker: {
//          componentId: wordpress_pen_component_id,
//          surfaces: [
//             {
//	              materialId: materialId,
//	              surfaceId: wordpress_surface_id,
//	              paletteId: wordpress_color_palette_id,
//	              colors: {
//	                 colorId: wordpress_color_code,
//	              }
//             },
//             ...
//          ]
//       },
//       ...
//       optionPicker: {
//          componentId: wordpress_pen_component_id,
//          surfaces: [
//             {
//	              materialId: materialId,
//	              surfaceId: wordpress_surface_id,
//	              paletteId: wordpress_color_palette_id,
//	              colors: {
//	                 colorId: wordpress_color_code,
//	              }
//             },
//             ...
//          ]
//       },
//       ...
//    }
var mapping = {};

// DS1
mapping['1100'] = {
	modelId: {
		'en': 197,
		'de': 1169
	},
	propertyPicker2_1: {
		componentId: { // Cap
			'en': 250,
			'de': 1202
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 204,
					'de': 1188
				},
				paletteId: {
					'en': 212,
					'de': 1180
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1113: 'F20',
					1211: 'F50',
					1212: 'F55',
					1213: 'F75',
					1569: 'F75',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 205,
					'de': 1189
				},
				paletteId: {
					'en': 213,
					'de': 1181
				},
				colors: {
					1567: 'T01',
					1209: 'T10',
					1113: 'T20',
					1215: 'T47',
					1211: 'T50',
					1212: 'T55',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 207,
					'de': 1192
				},
				paletteId: {
					'en': 214,
					'de': 1182
				},
				colors: {
					1207: 'P02',
					1208: 'P06',
					1209: 'P10',
					1202: 'P52',
					1573: 'P58',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 206,
					'de': 1190
				},
				paletteId: {
					'en': 215,
					'de': 1183
				},
				colors: {
					1207: 'M02',
					1571: 'M23',
					1570: 'M49',
					1572: 'M70',
					1569: 'M75',
				}
			},
		],
	},
	propertyPicker2_2: { // Pen
		componentId: {
			'en': 249,
			'de': 1201
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 204,
					'de': 1188
				},
				paletteId: {
					'en': 212,
					'de': 1180
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1113: 'F20',
					1211: 'F50',
					1212: 'F55',
					1213: 'F75',
					1569: 'F75',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 205,
					'de': 1189
				},
				paletteId: {
					'en': 213,
					'de': 1181
				},
				colors: {
					1567: 'T01',
					1209: 'T10',
					1113: 'T20',
					1215: 'T47',
					1211: 'T50',
					1212: 'T55',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 207,
					'de': 1192
				},
				paletteId: {
					'en': 214,
					'de': 1182
				},
				colors: {
					1207: 'P02',
					1208: 'P06',
					1209: 'P10',
					1202: 'P52',
					1573: 'P58',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 206,
					'de': 1190
				},
				paletteId: {
					'en': 215,
					'de': 1183
				},
				colors: {
					1207: 'M02',
					1571: 'M23',
					1570: 'M49',
					1572: 'M70',
					1569: 'M75',
				}
			},
		],
	},
	propertyPicker3: { // Nose cone
		componentId: {
			'en': 252,
			'de': 1203
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 204,
					'de': 1188
				},
				paletteId: {
					'en': 212,
					'de': 1180
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1113: 'F20',
					1211: 'F50',
					1212: 'F55',
					1213: 'F75',
					1569: 'F75',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 205,
					'de': 1189
				},
				paletteId: {
					'en': 213,
					'de': 1181
				},
				colors: {
					1567: 'T01',
					1209: 'T10',
					1113: 'T20',
					1215: 'T47',
					1211: 'T50',
					1212: 'T55',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 207,
					'de': 1192
				},
				paletteId: {
					'en': 214,
					'de': 1182
				},
				colors: {
					1207: 'P02',
					1208: 'P06',
					1209: 'P10',
					1202: 'P52',
					1573: 'P58',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 206,
					'de': 1190
				},
				paletteId: {
					'en': 215,
					'de': 1183
				},
				colors: {
					1207: 'M02',
					1571: 'M23',
					1570: 'M49',
					1572: 'M70',
					1569: 'M75',
				}
			},
			{
				materialId: 1186, // Satin finish metal
				surfaceId: {
					'en': 208,
					'de': 1193
				},
				paletteId: {
					'en': 253,
					'de': 1185
				},
				colors: {
					'': 'SS'
				}
			},
			{
				materialId: 1187, // Chrome finish metal
				surfaceId: {
					'en': 209,
					'de': 1194
				},
				paletteId: {
					'en': 254,
					'de': 1186
				},
				colors: {
					'': 'CC',
				}
			},
		],
	},
	optionPicker: { // Dot
		componentId: {
			'en': 255,
			'de': 1204
		},
		surfaces: [
			{
				materialId: 1185, // Polished (Dot)
				surfaceId: {
					'en': 550,
					'de': 1191
				},
				paletteId: {
					'en': 251,
					'de': 1184
				},
				colors: {
					1250: 'X01',
					1253: 'X06',
					1532: 'X10',
					1533: 'X20',
					1535: 'X23',
					1251: 'X47',
					1539: 'X49',
					1536: 'X52',
					1537: 'X55',
					1542: 'X58',
					1538: 'X70',
					1543: 'X75',
				}
			},
		],
	},
	optionPicker2: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
};

// DS2 e DS2 Metal nose cone
mapping['2325'] = {
	modelId: {
		'en': 266,
		'de': 1211
	},
	propertyPicker2_1: { // Cap
		componentId: {
			'en': 291,
			'de': 1236
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 280,
					'de': 225
				},
				paletteId: {
					'en': 269,
					'de': 1213
				},
				colors: 	{
					1567: 'F01',
					1208: 'F06',
					1209: 'F10',
					1113: 'F20',
					1236: 'F25',
					1210: 'F30',
					1213: 'F35',
					1215: 'F42',
					1237: 'F45',
					1211: 'F50',
					1212: 'F55',
					1238: 'F76',
				}
			},
			{
				materialId: 1120, // Tranpsarent
				surfaceId: {
					'en': 281,
					'de': 1226
				},
				paletteId: {
					'en': 270,
					'de': 1214
				},
				colors: 	{
					1567: 'T01',
					1208: 'T06',
					1209: 'T10',
					1113: 'T20',
					1236: 'T25',
					1210: 'T30',
					1213: 'T35',
					1215: 'T42',
					1237: 'T45',
					1211: 'T50',
					1212: 'F55',
					1238: 'T76',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 282,
					'de': 227
				},
				paletteId: {
					'en': 271,
					'de': 1215
				},
				colors: 	{
					1207: 'P02',
					1209: 'P10',
					1113: 'P20',
					1241: 'P41',
					1202: 'P52',
					1573: 'P58',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 283,
					'de': 1228
				},
				paletteId: {
					'en': 272,
					'de': 216
				},
				colors: 	{
					1207: 'M02',
					1569: 'M75',
				}
			},
			{
				materialId: 1189, // Varnished matt
				surfaceId: {
					'en': 284,
					'de': 1229
				},
				paletteId: {
					'en': 278,
					'de': 217
				},
				colors: 	{
					1235: 'V03',
					1598: 'V70',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 285,
					'de': 230
				},
				paletteId: {
					'en': 279,
					'de': 1230
				},
				colors: 	{
					1598: 'A70',
				}
			},
		],
	},
	propertyPicker2_2: { // Pen
		componentId: {
			'en': 290,
			'de': 1235
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 280,
					'de': 225
				},
				paletteId: {
					'en': 269,
					'de': 1213
				},
				colors: 	{
					1567: 'F01',
					1208: 'F06',
					1209: 'F10',
					1113: 'F20',
					1236: 'F25',
					1210: 'F30',
					1213: 'F35',
					1215: 'F42',
					1237: 'F45',
					1211: 'F50',
					1212: 'F55',
					1238: 'F76',
				}
			},
			{
				materialId: 1120, // Tranpsarent
				surfaceId: {
					'en': 281,
					'de': 1226
				},
				paletteId: {
					'en': 270,
					'de': 1214
				},
				colors: 	{
					1567: 'T01',
					1208: 'T06',
					1209: 'T10',
					1113: 'T20',
					1236: 'T25',
					1210: 'T30',
					1213: 'T35',
					1215: 'T42',
					1237: 'T45',
					1211: 'T50',
					1212: 'F55',
					1238: 'T76',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 282,
					'de': 227
				},
				paletteId: {
					'en': 271,
					'de': 1215
				},
				colors: 	{
					1207: 'P02',
					1209: 'P10',
					1113: 'P20',
					1241: 'P41',
					1202: 'P52',
					1573: 'P58',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 283,
					'de': 1228
				},
				paletteId: {
					'en': 272,
					'de': 216
				},
				colors: 	{
					1207: 'M02',
					1569: 'M75',
				}
			},
			{
				materialId: 1189, // Varnished matt
				surfaceId: {
					'en': 284,
					'de': 1229
				},
				paletteId: {
					'en': 278,
					'de': 217
				},
				colors: 	{
					1235: 'V03',
					1598: 'V70',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 285,
					'de': 230
				},
				paletteId: {
					'en': 279,
					'de': 1230
				},
				colors: 	{
					1598: 'A70',
				}
			},
		],
	},
	propertyPicker3: { // Nose cone
		componentId: {
			'en': 548,
			'de': 1238
		},
		surfaces: [
			{
				materialId: 1186, // Satin finish metal
				surfaceId: {
					'en': 758,
					'de': 1234
				},
				paletteId: {
					'en': 759,
					'de': 1223
				},
				colors: 	{
					'': 'S',
				}
			},
			{
				materialId: 1187, // Chrome finish metal
				surfaceId: {
					'en': 657,
					'de': 1233
				},
				paletteId: {
					'en': 658,
					'de': 1222
				},
				colors: 	{
					'': 'C',
				}
			},
		],
	},
	optionPicker: { // Button
		componentId: {
			'en': 292,
			'de': 1237
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 280,
					'de': 1225
				},
				paletteId: {
					'en': 269,
					'de': 1213
				},
				colors: {
					1250: 'F01',
					1253: 'F06',
					1532: 'F10',
					1533: 'F20',
					1534: 'F25',
					1535: 'F30',
					1539: 'F35',
					1541: 'F42',
					2470: 'F45',
					1538: 'F50',
					1537: 'F55',
					1789: 'F76',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 281,
					'de': 1226
				},
				paletteId: {
					'en': 275,
					'de': 1214
				},
				colors: {
					1787: 'T01',
					1253: 'T06',
					1532: 'T10',
					1533: 'T20',
					1534: 'T25',
					1535: 'T30',
					1539: 'T35',
					1541: 'T42',
					2470: 'T45',
					1538: 'T50',
					1537: 'T55',
					1789: 'T76',
					25332: 'T81',
					25333: 'T82',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 282,
					'de': 1227
				},
				paletteId: {
					'en': 271,
					'de': 1215
				},
				colors: {
					1252: 'P02',
					1532: 'P10',
					1533: 'P20',
					1784: 'P41',
					1536: 'P52',
					1785: 'P58',
					1543: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 283,
					'de': 1228
				},
				paletteId: {
					'en': 272,
					'de': 1216
				},
				colors: {
					1252: 'M02',
					1543: 'M75',
				}
			},
			{
				materialId: 1190, // Galvanised satin
				surfaceId: {
					'en': 288,
					'de': 1233
				},
				paletteId: {
					'en': 286,
					'de': 1220
				},
				colors: {
					2064: 'Y70',
				}
			},
			{
				materialId: 1191, // Galvanised chrome
				surfaceId: {
					'en': 289,
					'de': 1232
				},
				paletteId: {
					'en': 287,
					'de': 1220
				},
				colors: {
					2065: 'Z70',
				}
			},
		],
	},
	optionPicker2: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
};

// DS3
mapping['1128'] = {
	modelId: {
		'en': 420,
		'de': 1245
	},
	propertyPicker2_1: { // Cap
		componentId: {
			'en': 648,
			'de': 1280
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 563,
					'de': 1268
				},
				paletteId: {
					'en': 640,
					'de': 1247
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1209: 'F10',
					1113: 'F20',
					1236: 'F25',
					1210: 'F30',
					1213: 'F35',
					1214: 'F40',
					1215: 'F42',
					1211: 'F50',
					1212: 'F55',
					1216: 'F75',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 564,
					'de': 1269
				},
				paletteId: {
					'en': 641,
					'de': 1248
				},
				colors: 	{
					1567: 'T01',
					1208: 'T06',
					1209: 'T10',
					1113: 'T20',
					1236: 'T25',
					1210: 'T30',
					1213: 'T35',
					1214: 'T40',
					1215: 'T42',
					1211: 'T50',
					1212: 'T55',
					1216: 'T75',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 565,
					'de': 1270
				},
				paletteId: {
					'en': 642,
					'de': 1249
				},
				colors: 	{
					1207: 'P02',
					1208: 'P06',
					1209: 'P10',
					1113: 'P20',
					1202: 'P52',
					1573: 'P58',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 566,
					'de': 1271
				},
				paletteId: {
					'en': 643,
					'de': 1250
				},
				colors: 	{
					1207: 'M02',
					1569: 'M75',
				}
			},
			{
				materialId: 1189, // Varnished matt
				surfaceId: {
					'en': 567,
					'de': 1272
				},
				paletteId: {
					'en': 644,
					'de': 1251
				},
				colors: 	{
					1235: 'V03',
					1602: 'V50',
					1240: 'V51',
					1598: 'V70',
					1604: 'V75',
					1605: 'V80',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 568,
					'de': 1273
				},
				paletteId: {
					'en': 645,
					'de': 1252
				},
				colors: 	{
					1598: 'A70',
				}
			},
			{
				materialId: 1195, // Soft Touch
				surfaceId: {
					'en': 569,
					'de': 1274
				},
				paletteId: {
					'en': 647,
					'de': 1253
				},
				colors: 	{
					1235: 'R10',
					1602: 'R21',
					1240: 'R50',
					1598: 'R75',
				}
			},
		],
	},
	propertyPicker2_2: { // Pen
		componentId: {
			'en': 561,
			'de': 1278
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 563,
					'de': 1268
				},
				paletteId: {
					'en': 640,
					'de': 1247
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1209: 'F10',
					1113: 'F20',
					1236: 'F25',
					1210: 'F30',
					1213: 'F35',
					1214: 'F40',
					1215: 'F42',
					1211: 'F50',
					1212: 'F55',
					1216: 'F75',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 564,
					'de': 1269
				},
				paletteId: {
					'en': 641,
					'de': 1248
				},
				colors: 	{
					1567: 'T01',
					1208: 'T06',
					1209: 'T10',
					1113: 'T20',
					1236: 'T25',
					1210: 'T30',
					1213: 'T35',
					1214: 'T40',
					1215: 'T42',
					1211: 'T50',
					1212: 'T55',
					1216: 'T75',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 564,
					'de': 1269
				},
				paletteId: {
					'en': 641,
					'de': 1248
				},
				colors: 	{
					1207: 'P02',
					1208: 'P06',
					1209: 'P10',
					1113: 'P20',
					1202: 'P52',
					1573: 'P58',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 564,
					'de': 1269
				},
				paletteId: {
					'en': 641,
					'de': 1248
				},
				colors: 	{
					1207: 'M02',
					1569: 'M75',
				}
			},
			{
				materialId: 1189, // Varnished matt
				surfaceId: {
					'en': 567,
					'de': 1272
				},
				paletteId: {
					'en': 644,
					'de': 1251
				},
				colors: 	{
					1235: 'V03',
					1602: 'V50',
					1240: 'V51',
					1598: 'V70',
					1604: 'V75',
					1605: 'V80',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 567,
					'de': 1272
				},
				paletteId: {
					'en': 644,
					'de': 1251
				},
				colors: 	{
					1598: 'A70',
				}
			},
			{
				materialId: 1195, // Soft Touch
				surfaceId: {
					'en': 569,
					'de': 1274
				},
				paletteId: {
					'en': 647,
					'de': 1253
				},
				colors: 	{
					1235: 'R10',
					1602: 'R21',
					1240: 'R50',
					1598: 'R75',
				}
			},
		],
	},
	propertyPicker3: { // Nose cone
		componentId: {
			'en': 649,
			'de': 1281
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 563,
					'de': 1268
				},
				paletteId: {
					'en': 640,
					'de': 1247
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1209: 'F10',
					1113: 'F20',
					1236: 'F25',
					1210: 'F30',
					1213: 'F35',
					1214: 'F40',
					1215: 'F42',
					1211: 'F50',
					1212: 'F55',
					1216: 'F75',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 564,
					'de': 1269
				},
				paletteId: {
					'en': 641,
					'de': 1248
				},
				colors: 	{
					1567: 'T01',
					1208: 'T06',
					1209: 'T10',
					1113: 'T20',
					1236: 'T25',
					1210: 'T30',
					1213: 'T35',
					1214: 'T40',
					1215: 'T42',
					1211: 'T50',
					1212: 'T55',
					1216: 'T75',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 565,
					'de': 1270
				},
				paletteId: {
					'en': 642,
					'de': 1249
				},
				colors: 	{
					1207: 'P02',
					1208: 'P06',
					1209: 'P10',
					1113: 'P20',
					1202: 'P52',
					1573: 'P58',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 566,
					'de': 1271
				},
				paletteId: {
					'en': 643,
					'de': 1250
				},
				colors: 	{
					1207: 'M02',
					1569: 'M75',
				}
			},
			{
				materialId: 1189, // Varnished matt
				surfaceId: {
					'en': 567,
					'de': 1272
				},
				paletteId: {
					'en': 644,
					'de': 1251
				},
				colors: 	{
					1235: 'V03',
					1602: 'V50',
					1240: 'V51',
					1598: 'V70',
					1604: 'V75',
					1605: 'V80',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 568,
					'de': 1273
				},
				paletteId: {
					'en': 645,
					'de': 1252
				},
				colors: 	{
					1598: 'A70',
				}
			},
			{
				materialId: 1195, // Soft Touch
				surfaceId: {
					'en': 569,
					'de': 1274
				},
				paletteId: {
					'en': 647,
					'de': 1253
				},
				colors: 	{
					1235: 'R10',
					1602: 'R21',
					1240: 'R50',
					1598: 'R75',
				}
			},
			{
				materialId: 1186, // Satin finish metal
				surfaceId: {
					'en': 652,
					'de': 1275
				},
				paletteId: {
					'en': 650,
					'de': 1254
				},
				colors: 	{
					'': 'S',
				}
			},
			{
				materialId: 1187, // Chrome finish metal
				surfaceId: {
					'en': 653,
					'de': 1276
				},
				paletteId: {
					'en': 651,
					'de': 1255
				},
				colors: 	{
					'': 'C',
				}
			},
		],
	},
	optionPicker: { // Ring
		componentId: {
			'en': 654,
			'de': 1279
		},
		surfaces: [
			{
				materialId: 1568, // Polished (Ring)
				surfaceId: {
					'en': 655,
					'de': 1277
				},
				paletteId: {
					'en': 656,
					'de': 1256
				},
				colors: {
					1251: 'X01',
					1253: 'X06',
					1532: 'X10',
					1533: 'X20',
					1534: 'X25',
					1535: 'X30',
					1539: 'X35',
					1540: 'X40',
					1541: 'X42',
					1536: 'X52',
					1537: 'X55',
					1538: 'X58',
					1530: 'X70',
					1543: 'X75',
				}
			},
		],
	},
	optionPicker2: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
};

	// DS3 Biotic
	mapping['1128B'] = {
		modelId: {
			'en': 423,
			'de': 1258
		},
		propertyPicker2_1: { // Cap
			componentId: {
				'en': '',
				'de': ''
			},
			surfaces: [],
		},
		propertyPicker2_2: { // Pen
			componentId: {
				'en': 673,
				'de': 1267
			},
			surfaces: [
				{
					materialId: 1192, // Biotic
					surfaceId: {
						'en': 582,
						'de': 1262
					},
					paletteId: {
						'en': 662,
						'de': 1260
					},
					colors: 	{
						1554: 'B02',
						1553: 'B04',
						1555: 'B10',
						1556: 'B21',
						1558: 'B40',
						1557: 'B52',
						1559: 'B75',
					}
				},
			],
		},
		propertyPicker3: {
			componentId: {
				'en': '',
				'de': ''
			},
			surfaces: [],
		},
		optionPicker: {
			componentId: {
				'en': '',
				'de': ''
			},
			surfaces: [],
		},
		optionPicker2: {
			componentId: {
				'en': '',
				'de': ''
			},
			surfaces: [],
		},
	};
	
	// DS3 Mechanical pencil
	mapping['1128M'] = {
		modelId: {
			'en': 421,
			'de': 1287
		},
		propertyPicker2_1: { // Cap
			componentId: {
				'en': 675,
				'de': 1301
			},
			surfaces: [
				{
					materialId: 1119, // Frosted
					surfaceId: {
						'en': 583,
						'de': 1295
					},
					paletteId: {
						'en': 663,
						'de': 1289
					},
					colors: 	{
						1229: 'F01',
						1208: 'F06',
						1209: 'F10',
						1212: 'F55',
						1216: 'F75',
					}
				},
				{
					materialId: 1120, // Transparent
					surfaceId: {
						'en': 584,
						'de': 1296
					},
					paletteId: {
						'en': 664,
						'de': 1290
					},
					colors: 	{
						1567: 'T01',
						1208: 'T06',
						1209: 'T10',
						1212: 'T55',
						1216: 'T75',
					}
				},
			],
		},
		propertyPicker2_2: { // Pen
			componentId: {
				'en': 674,
				'de': 1300
			},
			surfaces: [
				{
					materialId: 1119, // Frosted
					surfaceId: {
						'en': 583,
						'de': 1295
					},
					paletteId: {
						'en': 663,
						'de': 1289
					},
					colors: 	{
						1229: 'F01',
						1208: 'F06',
						1209: 'F10',
						1212: 'F55',
						1216: 'F75',
					}
				},
				{
					materialId: 1120, // Transparent
					surfaceId: {
						'en': 584,
						'de': 1296
					},
					paletteId: {
						'en': 664,
						'de': 1290
					},
					colors: 	{
						1567: 'T01',
						1208: 'T06',
						1209: 'T10',
						1212: 'T55',
						1216: 'T75',
					}
				},
			],
		},
		propertyPicker3: { // Nose cone
			componentId: {
				'en': 676,
				'de': 1302
			},
			surfaces: [
				{
					materialId: 1119, // Frosted
					surfaceId: {
						'en': 583,
						'de': 1295
					},
					paletteId: {
						'en': 663,
						'de': 1289
					},
					colors: 	{
						1229: 'F01',
						1208: 'F06',
						1209: 'F10',
						1212: 'F55',
						1216: 'F75',
					}
				},
				{
					materialId: 1120, // Transparent
					surfaceId: {
						'en': 584,
						'de': 1296
					},
					paletteId: {
						'en': 664,
						'de': 1290
					},
					colors: 	{
						1567: 'T01',
						1208: 'T06',
						1209: 'T10',
						1212: 'T55',
						1216: 'T75',
					}
				},
				{
					materialId: 1186, // Satin finish metal
					surfaceId: {
						'en': 678,
						'de': 1297
					},
					paletteId: {
						'en': 665,
						'de': 1291
					},
					colors: {
						'': 'S',
					}
				},
				{
					materialId: 1187, // Chrome finish metal
					surfaceId: {
						'en': 679,
						'de': 1298
					},
					paletteId: {
						'en': 666,
						'de': 1292
					},
					colors: {
						'': 'C',
					}
				},
			],
		},
		optionPicker: { // Ring
			componentId: {
				'en': 677,
				'de': 1303
			},
			surfaces: [
				{
					materialId: 1568, // Polished (Ring)
					surfaceId: {
						'en': 680,
						'de': 1299
					},
					paletteId: {
						'en': 667,
						'de': 1293
					},
					colors: {
						1251: 'X01',
						1253: 'X06',
						1532: 'X10',
						1533: 'X20',
						1534: 'X25',
						1535: 'X30',
						1539: 'X35',
						1540: 'X40',
						1541: 'X42',
						1546: 'X52',
						1537: 'X55',
						1538: 'X58',
						1530: 'X70',
						1543: 'X75',
					}
				},
			],
		},
		optionPicker2: {
			componentId: {
				'en': '',
				'de': ''
			},
			surfaces: [],
		},
	};

// DS3.1
mapping['1430'] = {
	modelId: {
		'en': 422,
		'de': 1309
	},
	propertyPicker2_1: { // Cap
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
	propertyPicker2_2: { // Pen
		componentId: {
			'en': 683,
			'de': 1322
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 585,
					'de': 1317
				},
				paletteId: {
					'en': 668,
					'de': 1311
				},
				colors: 	{
					1229: 'F01',
					1243: 'F26',
					1246: 'F59',
					1216: 'F75',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 586,
					'de': 1318
				},
				paletteId: {
					'en': 669,
					'de': 1312
				},
				colors: 	{
					1567: 'T01',
					1242: 'T10',
					1236: 'T25',
					1243: 'T26',
					1210: 'T30',
					1244: 'T36',
					1841: 'T48',
					47664: 'T53',
					1212: 'T55',
					1246: 'T59',
					1842: 'T75',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 587,
					'de': 1319
				},
				paletteId: {
					'en': 670,
					'de': 1313
				},
				colors: 	{
					1207: 'P02',
					1570: 'P07',
					1571: 'P20',
					1572: 'P31',
					1569: 'P75',
					1573: 'P77',
				}
			},
		],
	},
	propertyPicker3: { // Nose cone
		componentId: {
			'en': 684,
			'de': 1323
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 585,
					'de': 1317
				},
				paletteId: {
					'en': 668,
					'de': 1311
				},
				colors: 	{
					1229: 'F01',
					1243: 'F26',
					1246: 'F59',
					1216: 'F75',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 586,
					'de': 1318
				},
				paletteId: {
					'en': 669,
					'de': 1312
				},
				colors: 	{
					1567: 'T01',
					1242: 'T10',
					1236: 'T25',
					1243: 'T26',
					1210: 'T30',
					1244: 'T36',
					1841: 'T48',
					47664: 'T53',
					1212: 'T55',
					1246: 'T59',
					1842: 'T75',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 587,
					'de': 1319
				},
				paletteId: {
					'en': 670,
					'de': 1313
				},
				colors: 	{
					1207: 'P02',
					1570: 'P07',
					1571: 'P20',
					1572: 'P31',
					1569: 'P75',
					1573: 'P77',
				}
			},
			{
				materialId: 1186, // Satin finish metal
				surfaceId: {
					'en': 681,
					'de': 1320
				},
				paletteId: {
					'en': 671,
					'de': 1314
				},
				colors: 	{
					'': 'S',
				}
			},
			{
				materialId: 1187, // Chrome finish metal
				surfaceId: {
					'en': 682,
					'de': 1321
				},
				paletteId: {
					'en': 672,
					'de': 1315
				},
				colors: 	{
					'': 'C',
				}
			},
		],
	},
	optionPicker: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
	optionPicker2: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
};

// DS5
mapping['1432'] = {
	modelId: {
		'en': 424,
		'de': 1329
	},
	propertyPicker2_1: { // Cap
		componentId: {
			'en': 719,
			'de': 1353
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 588,
					'de': 1342
				},
				paletteId: {
					'en': 707,
					'de': 1331
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1209: 'F10',
					1239: 'F21',
					1210: 'F30',
					1213: 'F35',
					1241: 'F41',
					1215: 'F42',
					1211: 'F50',
					1240: 'F51',
					1238: 'F76',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 589,
					'de': 1343
				},
				paletteId: {
					'en': 708,
					'de': 1332
				},
				colors: 	{
					1229: 'T01',
					1208: 'T06',
					1209: 'T10',
					1239: 'T21',
					1210: 'T30',
					1213: 'T35',
					1241: 'T41',
					1215: 'T42',
					1211: 'T50',
					1240: 'T51',
					1238: 'T76',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 590,
					'de': 1344
				},
				paletteId: {
					'en': 709,
					'de': 1333
				},
				colors: 	{
					1207: 'P02',
					1208: 'P06',
					1209: 'P10',
					1113: 'P20',
					1202: 'P52',
					1573: 'P58',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 591,
					'de': 1345
				},
				paletteId: {
					'en': 710,
					'de': 1334
				},
				colors: 	{
					1207: 'M02',
					1569: 'M75',
				}
			},
			{
				materialId: 1189, // Varnished matt
				surfaceId: {
					'en': 592,
					'de': 1346
				},
				paletteId: {
					'en': 711,
					'de': 1335
				},
				colors: 	{
					1235: 'V03',
					1602: 'V50',
					1603: 'V51',
					1598: 'V70',
					1604: 'V75',
					1605: 'V80',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 593,
					'de': 1347
				},
				paletteId: {
					'en': 712,
					'de': 1336
				},
				colors: 	{
					1598: 'A70',
				}
			},
			{
				materialId: 1195, // Soft Touch
				surfaceId: {
					'en': 594,
					'de': 1348
				},
				paletteId: {
					'en': 713,
					'de': 1337
				},
				colors: 	{
					1569: 'R75',
				}
			},
		],
	},
	propertyPicker2_2: { // Pen
		componentId: {
			'en': 716,
			'de': 1352
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 588,
					'de': 1342
				},
				paletteId: {
					'en': 707,
					'de': 1331
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1209: 'F10',
					1239: 'F21',
					1210: 'F30',
					1213: 'F35',
					1241: 'F41',
					1215: 'F42',
					1211: 'F50',
					1240: 'F51',
					1238: 'F76',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 589,
					'de': 1343
				},
				paletteId: {
					'en': 708,
					'de': 1332
				},
				colors: 	{
					1229: 'T01',
					1208: 'T06',
					1209: 'T10',
					1239: 'T21',
					1210: 'T30',
					1213: 'T35',
					1241: 'T41',
					1215: 'T42',
					1211: 'T50',
					1240: 'T51',
					1238: 'T76',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 590,
					'de': 1344
				},
				paletteId: {
					'en': 709,
					'de': 1333
				},
				colors: 	{
					1207: 'P02',
					1208: 'P06',
					1209: 'P10',
					1113: 'P20',
					1202: 'P52',
					1573: 'P58',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 591,
					'de': 1345
				},
				paletteId: {
					'en': 710,
					'de': 1334
				},
				colors: 	{
					1207: 'M02',
					1569: 'M75',
				}
			},
			{
				materialId: 1189, // Varnished matt
				surfaceId: {
					'en': 592,
					'de': 1346
				},
				paletteId: {
					'en': 711,
					'de': 1335
				},
				colors: 	{
					1235: 'V03',
					1602: 'V50',
					1603: 'V51',
					1598: 'V70',
					1604: 'V75',
					1605: 'V80',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 593,
					'de': 1347
				},
				paletteId: {
					'en': 712,
					'de': 1336
				},
				colors: 	{
					1598: 'A70',
				}
			},
			{
				materialId: 1195, // Soft Touch
				surfaceId: {
					'en': 594,
					'de': 1348
				},
				paletteId: {
					'en': 713,
					'de': 1337
				},
				colors: 	{
					1569: 'R75',
				}
			},
		],
	},
	propertyPicker3: { // Nose cone
		componentId: {
			'en': 720,
			'de': 1354
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 588,
					'de': 1342
				},
				paletteId: {
					'en': 707,
					'de': 1331
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1209: 'F10',
					1239: 'F21',
					1210: 'F30',
					1213: 'F35',
					1241: 'F41',
					1215: 'F42',
					1211: 'F50',
					1240: 'F51',
					1238: 'F76',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 589,
					'de': 1343
				},
				paletteId: {
					'en': 708,
					'de': 1332
				},
				colors: 	{
					1229: 'T01',
					1208: 'T06',
					1209: 'T10',
					1239: 'T21',
					1210: 'T30',
					1213: 'T35',
					1241: 'T41',
					1215: 'T42',
					1211: 'T50',
					1240: 'T51',
					1238: 'T76',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 590,
					'de': 1344
				},
				paletteId: {
					'en': 709,
					'de': 1333
				},
				colors: 	{
					1207: 'P02',
					1208: 'P06',
					1209: 'P10',
					1113: 'P20',
					1202: 'P52',
					1573: 'P58',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 591,
					'de': 1345
				},
				paletteId: {
					'en': 710,
					'de': 1334
				},
				colors: 	{
					1207: 'M02',
					1569: 'M75',
				}
			},
			{
				materialId: 1189, // Varnished matt
				surfaceId: {
					'en': 592,
					'de': 1346
				},
				paletteId: {
					'en': 711,
					'de': 1335
				},
				colors: 	{
					1235: 'V03',
					1602: 'V50',
					1603: 'V51',
					1598: 'V70',
					1604: 'V75',
					1605: 'V80',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 593,
					'de': 1347
				},
				paletteId: {
					'en': 712,
					'de': 1336
				},
				colors: 	{
					1598: 'A70',
				}
			},
			{
				materialId: 1195, // Soft Touch
				surfaceId: {
					'en': 594,
					'de': 1348
				},
				paletteId: {
					'en': 713,
					'de': 1337
				},
				colors: 	{
					1569: 'R75',
				}
			},
			{
				materialId: 1186, // Satin finish metal
				surfaceId: {
					'en': 717,
					'de': 1349
				},
				paletteId: {
					'en': 714,
					'de': 1338
				},
				colors: 	{
					'': 'S',
				}
			},
			{
				materialId: 1187, // Chrome finish metal
				surfaceId: {
					'en': 718,
					'de': 1350
				},
				paletteId: {
					'en': 715,
					'de': 1339
				},
				colors: 	{
					'': 'C',
				}
			},
		],
	},
	optionPicker: { // Clip cover
		componentId: {
			'en': 721,
			'de': 1355
		},
		surfaces: [
			{
				materialId: 1185, // Polished (Clip)
				surfaceId: {
					'en': 590,
					'de': 1344
				},
				paletteId: {
					'en': 727,
					'de': 1340
				},
				colors: {
					1252: 'P02',
					1532: 'P10',
					1533: 'P20',
					1536: 'P52',
					1786: 'P58',
					1543: 'P75',
				}
			},
			{
				materialId: 1121, // Matt (Clip)
				surfaceId: {
					'en': 591,
					'de': 1345
				},
				paletteId: {
					'en': 710,
					'de': 1334
				},
				colors: {
					1252: 'M02',
					1543: 'M75',
				}
			},
		],
	},
	optionPicker2: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
};

// DS7
mapping['1433'] = {
	modelId: {
		'en': 425,
		'de': 1361
	},
	propertyPicker2_1: { // Cap
		componentId: {
			'en': 739,
			'de': 1383
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 595,
					'de': 1374
				},
				paletteId: {
					'en': 730,
					'de': 1363
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1209: 'F10',
					1239: 'F21',
					1210: 'F30',
					1213: 'F35',
					1241: 'F41',
					1215: 'F42',
					1211: 'F50',
					1240: 'F51',
					1238: 'F76',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 596,
					'de': 1375
				},
				paletteId: {
					'en': 731,
					'de': 1364
				},
				colors: 	{
					1567: 'T01',
					1208: 'T06',
					1209: 'T10',
					1239: 'T21',
					1210: 'T30',
					1213: 'T35',
					1241: 'T41',
					1215: 'T42',
					1211: 'T50',
					1240: 'T51',
					1238: 'T76',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 597,
					'de': 1376
				},
				paletteId: {
					'en': 732,
					'de': 1365
				},
				colors: 	{
					1207: 'P02',
					1209: 'P10',
					1113: 'P20',
					1241: 'P41',
					49408: 'P53',
					49409: 'P74',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 598,
					'de': 1377
				},
				paletteId: {
					'en': 733,
					'de': 1366
				},
				colors: 	{
					1207: 'M02',
					1569: 'M75',
				}
			},
			{
				materialId: 1189, // Varnished matt
				surfaceId: {
					'en': 600,
					'de': 1378
				},
				paletteId: {
					'en': 734,
					'de': 1367
				},
				colors: 	{
					1235: 'V03',
					1598: 'V70',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 601,
					'de': 1379
				},
				paletteId: {
					'en': 735,
					'de': 1368
				},
				colors: 	{
					1598: 'A70',
				}
			},
		],
	},
	propertyPicker2_2: { // Pen
		componentId: {
			'en': 729,
			'de': 1382
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 595,
					'de': 1374
				},
				paletteId: {
					'en': 730,
					'de': 1363
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1209: 'F10',
					1239: 'F21',
					1210: 'F30',
					1213: 'F35',
					1241: 'F41',
					1215: 'F42',
					1211: 'F50',
					1240: 'F51',
					1238: 'F76',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 596,
					'de': 1375
				},
				paletteId: {
					'en': 731,
					'de': 1364
				},
				colors: 	{
					1567: 'T01',
					1208: 'T06',
					1209: 'T10',
					1239: 'T21',
					1210: 'T30',
					1213: 'T35',
					1241: 'T41',
					1215: 'T42',
					1211: 'T50',
					1240: 'T51',
					1238: 'T76',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 597,
					'de': 1376
				},
				paletteId: {
					'en': 732,
					'de': 1365
				},
				colors: 	{
					1207: 'P02',
					1209: 'P10',
					1113: 'P20',
					1241: 'P41',
					49408: 'P53',
					49409: 'P74',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 598,
					'de': 1377
				},
				paletteId: {
					'en': 733,
					'de': 1366
				},
				colors: 	{
					1207: 'M02',
					1569: 'M75',
				}
			},
			{
				materialId: 1189, // Varnished matt
				surfaceId: {
					'en': 600,
					'de': 1378
				},
				paletteId: {
					'en': 734,
					'de': 1367
				},
				colors: 	{
					1235: 'V03',
					1598: 'V70',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: 601,
				surfaceId: {
					'en': 601,
					'de': 1379
				},
				paletteId: {
					'en': 735,
					'de': 1368
				},
				colors: 	{
					1598: 'A70',
				}
			},
		],
	},
	propertyPicker3: { // Nose cone
		componentId: {
			'en': 740,
			'de': 1384
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 595,
					'de': 1374
				},
				paletteId: {
					'en': 730,
					'de': 1363
				},
				colors: 	{
					1229: 'F01',
					1208: 'F06',
					1209: 'F10',
					1239: 'F21',
					1210: 'F30',
					1213: 'F35',
					1241: 'F41',
					1215: 'F42',
					1211: 'F50',
					1240: 'F51',
					1238: 'F76',
				}
			},
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 596,
					'de': 1375
				},
				paletteId: {
					'en': 731,
					'de': 1364
				},
				colors: 	{
					1567: 'T01',
					1208: 'T06',
					1209: 'T10',
					1239: 'T21',
					1210: 'T30',
					1213: 'T35',
					1241: 'T41',
					1215: 'T42',
					1211: 'T50',
					1240: 'T51',
					1238: 'T76',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 597,
					'de': 1376
				},
				paletteId: {
					'en': 732,
					'de': 1365
				},
				colors: 	{
					1207: 'P02',
					1209: 'P10',
					1113: 'P20',
					1241: 'P41',
					49408: 'P53',
					49409: 'P74',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 598,
					'de': 1377
				},
				paletteId: {
					'en': 733,
					'de': 1366
				},
				colors: 	{
					1207: 'M02',
					1569: 'M75',
				}
			},
			{
				materialId: 1189, // Varnished matt
				surfaceId: {
					'en': 600,
					'de': 1378
				},
				paletteId: {
					'en': 734,
					'de': 1367
				},
				colors: 	{
					1235: 'V03',
					1598: 'V70',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 601,
					'de': 1379
				},
				paletteId: {
					'en': 735,
					'de': 1368
				},
				colors: 	{
					1598: 'A70',
				}
			},
			{
				materialId: 1186, // Satin finish metal
				surfaceId: {
					'en': 722,
					'de': 1380
				},
				paletteId: {
					'en': 737,
					'de': 1369
				},
				colors: 	{
					'': 'S',
				}
			},
			{
				materialId: 1187, // Chrome finish metal
				surfaceId: {
					'en': 723,
					'de': 1381
				},
				paletteId: {
					'en': 738,
					'de': 1370
				},
				colors: 	{
					'': 'C',
				}
			},
		],
	},
	optionPicker: { // Button
		componentId: {
			'en': 741,
			'de': 1385
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 595,
					'de': 1374
				},
				paletteId: {
					'en': 730,
					'de': 1363
				},
				colors: {
					1251: 'F01',
					1253: 'F06',
					1532: 'F10',
					2066: 'F21',
					1535: 'F30',
					1539: 'F35',
					1784: 'F41',
					1541: 'F42',
					1538: 'F50',
					2067: 'F51',
					1789: 'F76',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 598,
					'de': 1377
				},
				paletteId: {
					'en': 1014,
					'de': 1371
				},
				colors: {
					1252: 'M02',
					1532: 'M10',
					2066: 'M21',
					1784: 'M41',
					2068: 'M53',
					2069: 'M74',
					1543: 'M75',
				}
			},
		],
	},
	optionPicker2: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
};

// DS8
mapping['49413'] = {
	modelId: {
		'en': 426,
		'de': 1391
	},
	propertyPicker2_1: { // Cap
		componentId: {
			'en': 752,
			'de': 1409
		},
		surfaces: [
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 602,
					'de': 1402
				},
				paletteId: {
					'en': 742,
					'de': 1393
				},
				colors: 	{
					1207: 'P02',
					1209: 'P10',
					1113: 'P20',
					49440: 'P55',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 599,
					'de': 1403
				},
				paletteId: {
					'en': 743,
					'de': 1394
				},
				colors: 	{
					1207: 'M02',
					49407: 'M07',
					49429: 'M27',
					49430: 'M47',
					1573: 'M58',
					49428: 'M70',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 603,
					'de': 1404
				},
				paletteId: {
					'en': 744,
					'de': 1395
				},
				colors: 	{
					49405: 'A15',
					49449: 'A53',
					1598: 'A70',
					1604: 'A75',
				}
			},
			{
				materialId: 1195, // Soft Touch
				surfaceId: {
					'en': 604,
					'de': 1405
				},
				paletteId: {
					'en': 745,
					'de': 1396
				},
				colors: 	{
					1209: 'R10',
					49444: 'R21',
					1570: 'R28',
					1571: 'R48',
					1211: 'R50',
					1572: 'R54',
					1573: 'R70',
					1569: 'R75',
				}
			},
		],
	},
	propertyPicker2_2: { // Pen
		componentId: {
			'en': 751,
			'de': 1418
		},
		surfaces: [
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 602,
					'de': 1402
				},
				paletteId: {
					'en': 742,
					'de': 1393
				},
				colors: 	{
					1207: 'P02',
					1209: 'P10',
					1113: 'P20',
					49440: 'P55',
					1569: 'P75',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 599,
					'de': 1403
				},
				paletteId: {
					'en': 743,
					'de': 1394
				},
				colors: 	{
					1207: 'M02',
					49407: 'M07',
					49429: 'M27',
					49430: 'M47',
					1573: 'M58',
					49428: 'M70',
				}
			},
			{
				materialId: 1188, // Varnished polished
				surfaceId: {
					'en': 603,
					'de': 1404
				},
				paletteId: {
					'en': 744,
					'de': 1395
				},
				colors: 	{
					49405: 'A15',
					49449: 'A53',
					1598: 'A70',
					1604: 'A75',
				}
			},
			{
				materialId: 1195, // Soft Touch
				surfaceId: {
					'en': 604,
					'de': 1405
				},
				paletteId: {
					'en': 745,
					'de': 1396
				},
				colors: 	{
					1209: 'R10',
					49444: 'R21',
					1570: 'R28',
					1571: 'R48',
					1211: 'R50',
					1572: 'R54',
					1573: 'R70',
					1569: 'R75',
				}
			},
		],
	},
	propertyPicker3: { // Clip
		componentId: {
			'en': 753,
			'de': 1410
		},
		surfaces: [
			{
				materialId: 1185, // Polished (Clip)
				surfaceId: {
					'en': 602,
					'de': 1402
				},
				paletteId: {
					'en': 746,
					'de': 1397
				},
				colors: 	{
					1207: 'P02',
					1208: 'P75',
				}
			},
			{
				materialId: 2222, // Transparent (Clip)
				surfaceId: {
					'en': 724,
					'de': 1406
				},
				paletteId: {
					'en': 747,
					'de': 1398
				},
				colors: 	{
					1111: 'T01',
					1112: 'T07',
					1113: 'T10',
					1115: 'T15',
					1116: 'T21',
					1128: 'T27',
					1570: 'T28',
					1119: 'T47',
					1571: 'T48',
					1121: 'T50',
					1122: 'T53',
					1572: 'T54',
					1123: 'T75',
					1124: 'T76',
				}
			},
		],
	},
	optionPicker: { // Button
		componentId: {
			'en': 754,
			'de': 1411
		},
		surfaces: [
			{
				materialId: 1186, // Satin finish metal
				surfaceId: {
					'en': 725,
					'de': 1407
				},
				paletteId: {
					'en': 749,
					'de': 1399
				},
				colors: {
					49525: 'S',
				}
			},
			{
				materialId: 1187, // Chrome finish metal
				surfaceId: {
					'en': 726,
					'de': 1408
				},
				paletteId: {
					'en': 750,
					'de': 1400
				},
				colors: {
					49524: 'C',
				}
			},
		],
	},
	optionPicker2: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
};

	// DS8 Mechanical pencil
	mapping['49413M'] = {
		modelId: {
			'en': 427,
			'de': 1419
		},
		propertyPicker2_1: { // Cap
			componentId: {
				'en': '',
				'de': ''
			},
			surfaces: [
				{
					materialId: 1185, // Polished
					surfaceId: {
						'en': 605,
						'de': 1429
					},
					paletteId: {
						'en': 762,
						'de': 1421
					},
					colors: 	{
						1207: 'P02',
					}
				},
				{
					materialId: 1188, // Varnished polished
					surfaceId: {
						'en': 607,
						'de': 1430
					},
					paletteId: {
						'en': 763,
						'de': 1422
					},
					colors: 	{
						1598: 'A70',
					}
				},
				{
					materialId: 1195, // Soft Touch
					surfaceId: {
						'en': 608,
						'de': 1431
					},
					paletteId: {
						'en': 764,
						'de': 1423
					},
					colors: 	{
						49444: 'R21',
						1571: 'R48',
						1211: 'R50',
						1573: 'R70',
						1569: 'R75',
					}
				},
			],
		},
		propertyPicker2_2: { // Pen
			componentId: {
				'en': 805,
				'de': 1435
			},
			surfaces: [
				{
					materialId: 1185, // Polished
					surfaceId: {
						'en': 605,
						'de': 1429
					},
					paletteId: {
						'en': 762,
						'de': 1421
					},
					colors: 	{
						1207: 'P02',
					}
				},
				{
					materialId: 1188, // Varnished polished
					surfaceId: {
						'en': 607,
						'de': 1430
					},
					paletteId: {
						'en': 763,
						'de': 1422
					},
					colors: 	{
						1598: 'A70',
					}
				},
				{
					materialId: 1195, // Soft Touch
					surfaceId: {
						'en': 608,
						'de': 1431
					},
					paletteId: {
						'en': 764,
						'de': 1423
					},
					colors: 	{
						49444: 'R21',
						1571: 'R48',
						1211: 'R50',
						1573: 'R70',
						1569: 'R75',
					}
				},
			],
		},
		propertyPicker3: { // Clip
			componentId: {
				'en': 807,
				'de': 1436
			},
			surfaces: [
				{
					materialId: 1185, // Polished (Clip)
					surfaceId: {
						'en': 605,
						'de': 1429
					},
					paletteId: {
						'en': 768,
						'de': 1424
					},
					colors: 	{
						1207: 'P02',
						1208: 'P75',
					}
				},
				{
					materialId: 2222, // Transparent (Clip)
					surfaceId: {
						'en': 811,
						'de': 1432
					},
					paletteId: {
						'en': 765,
						'de': 1425
					},
					colors: 	{
						1116: 'T21',
						1571: 'T48',
						1121: 'T50',
						1123: 'T75',
						1124: 'T76',
					}
				},
			],
		},
		optionPicker: { // Button
			componentId: {
				'en': 808,
				'de': 1437
			},
			surfaces: [
				{
					materialId: 1186, // Satin finish metal
					surfaceId: {
						'en': 809,
						'de': 1433
					},
					paletteId: {
						'en': 766,
						'de': 1426
					},
					colors: {
						49525: 'S',
					}
				},
				{
					materialId: 1187, // Chrome finish metal
					surfaceId: {
						'en': 810,
						'de': 1434
					},
					paletteId: {
						'en': 767,
						'de': 1427
					},
					colors: {
						1250: 'C',
					}
				},
			],
		},
		optionPicker2: {
			componentId: {
				'en': '',
				'de': ''
			},
			surfaces: [],
		},
	};

// DS9 e DS9 Metal nose cone
// Non è possibile recuperare il "metal nose cone" perché non è presente tra i "propertyPicker"
mapping['50000'] = {
	modelId: {
		'en': 429,
		'de': 1444
	},
	propertyPicker2_1: { // Cap
		componentId: {
			'en': 813,
			'de': 1464
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 609,
					'de': 1455
				},
				paletteId: {
					'en': 774,
					'de': 1446
				},
				colors: 	{
					1567: 'F01',
					1209: 'F21',
					1113: 'F25',
					1236: 'F50',
					1210: 'F76',
					1208: 'F81',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 610,
					'de': 1456
				},
				paletteId: {
					'en': 775,
					'de': 1447
				},
				colors: 	{
					1567: 'M02',
					1208: 'M05',
					1209: 'M13',
					1113: 'M20',
					1236: 'M23',
					1211: 'M27',
					1214: 'M49',
					1213: 'M60',
					1212: 'M61',
					1216: 'M70',
					1218: 'M73',
					1217: 'M75',
					1215: 'M77',
					1219: 'M90',
				}
			},
		],
	},
	propertyPicker2_2: { // Pen
		componentId: {
			'en': 812,
			'de': 1463
		},
		surfaces: [
			{
				materialId: 1119, // Frosted
				surfaceId: {
					'en': 609,
					'de': 1455
				},
				paletteId: {
					'en': 774,
					'de': 1446
				},
				colors: 	{
					1567: 'F01',
					1209: 'F21',
					1113: 'F25',
					1236: 'F50',
					1210: 'F76',
					1208: 'F81',
				}
			},
			{
				materialId: 1121, // Matt
				surfaceId: {
					'en': 610,
					'de': 1456
				},
				paletteId: {
					'en': 775,
					'de': 1447
				},
				colors: 	{
					1567: 'M02',
					1208: 'M05',
					1209: 'M13',
					1113: 'M20',
					1236: 'M23',
					1211: 'M27',
					1214: 'M49',
					1213: 'M60',
					1212: 'M61',
					1216: 'M70',
					1218: 'M73',
					1217: 'M75',
					1215: 'M77',
					1219: 'M90',
				}
			},
		],
	},
	propertyPicker3: { // Ring
		componentId: {
			'en': 814,
			'de': 1467
		},
		surfaces: [
			{
				materialId: 1120, // Transparent (Ring)
				surfaceId: {
					'en': 772,
					'de': 1457
				},
				paletteId: {
					'en': 777,
					'de': 1448
				},
				colors: {
					1567: 'T01',
					1209: 'T21',
					1113: 'T25',
					1236: 'T50',
					1210: 'T76',
					1208: 'T81',
				}
			},
			{
				materialId: 1185, // Polished (Dot)
				surfaceId: {
					'en': 773,
					'de': 1459
				},
				paletteId: {
					'en': 920,
					'de': 1450
				},
				colors: {
					1567: 'P02',
					1208: 'P05',
					1209: 'P13',
					1113: 'P20',
					1236: 'P23',
					1211: 'P27',
					1214: 'P49',
					1213: 'P60',
					1212: 'P61',
					1216: 'P70',
					1218: 'P73',
					1217: 'P75',
					1215: 'P77',
					1219: 'P90',
				}
			},
		],
	},
	optionPicker: { // Button
		componentId: {
			'en': 815,
			'de': 1466
		},
		surfaces: [
			{
				materialId: 1120, // Transparent
				surfaceId: {
					'en': 772,
					'de': 1457
				},
				paletteId: {
					'en': 777,
					'de': 1448
				},
				colors: 	{
					1567: 'T01',
					1209: 'T21',
					1113: 'T25',
					1236: 'T50',
					1210: 'T76',
					1208: 'T81',
				}
			},
			{
				materialId: 1185, // Polished
				surfaceId: {
					'en': 773,
					'de': 1459
				},
				paletteId: {
					'en': 776,
					'de': 1449
				},
				colors: 	{
					1567: 'P02',
					1208: 'P05',
					1209: 'P13',
					1113: 'P20',
					1236: 'P23',
					1211: 'P27',
					1214: 'P49',
					1213: 'P60',
					1212: 'P61',
					1216: 'P70',
					1218: 'P73',
					1217: 'P75',
					1215: 'P77',
					1219: 'P90',
				}
			},
			{
				materialId: 1186, // Galvanised satin
				surfaceId: {
					'en': 769,
					'de': 1468
				},
				paletteId: {
					'en': 779,
					'de': 1451
				},
				colors: 	{
					'': 'Y70',
				}
			},
			{
				materialId: 1187, // Galvanised chrome
				surfaceId: {
					'en': 770,
					'de': 1460
				},
				paletteId: {
					'en': 780,
					'de': 1452
				},
				colors: 	{
					'': 'Z70',
				}
			},
		],
	},
	optionPicker2: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
};

// DS10
mapping['25342'] = {
	modelId: {
		'en': 430,
		'de': 1474
	},
	propertyPicker2_1: { // Cap
		componentId: {
			'en': 818,
			'de': 1484
		},
		surfaces: [
			{
				materialId: 11120, // Soft Touch
				surfaceId: {
					'en': 611,
					'de': 1480
				},
				paletteId: {
					'en': 781,
					'de': 1476
				},
				colors: 	{
					11229: 'R02',
					11211: 'R27',
					11239: 'R29',
					11216: 'R39',
					11218: 'R54',
					11209: 'R66',
					11217: 'R67',
					11219: 'R70',
					11220: 'R75',
				}
			},
		],
	},
	propertyPicker2_2: { // Pen
		componentId: {
			'en': 817,
			'de': 1483
		},
		surfaces: [
			{
				materialId: 11120, // Soft Touch
				surfaceId: {
					'en': 611,
					'de': 1480
				},
				paletteId: {
					'en': 781,
					'de': 1476
				},
				colors: 	{
					11229: 'R02',
					11211: 'R27',
					11239: 'R29',
					11216: 'R39',
					11218: 'R54',
					11209: 'R66',
					11217: 'R67',
					11219: 'R70',
					11220: 'R75',
				}
			},
		],
	},
	propertyPicker3: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
	optionPicker: { // Button
		componentId: {
			'en': 819,
			'de': 1485
		},
		surfaces: [
			{
				materialId: 1186, // Satin finish metal
				surfaceId: {
					'en': 782,
					'de': 1481
				},
				paletteId: {
					'en': 784,
					'de': 1477
				},
				colors: {
					'': 'S',
				}
			},
			{
				materialId: 1187, // Chrome finish metal
				surfaceId: {
					'en': 785,
					'de': 1482
				},
				paletteId: {
					'en': 786,
					'de': 1478
				},
				colors: {
					'': 'C',
				}
			},
		],
	},
	optionPicker2: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
};

// QS01
// Solo sul nuovo configuratore è possibile personalizzare il "button" indipendentemente dalla "clip"
// Solo sul nuovo configuratore sono presenti nuove finiture e palette di colori
mapping['1000'] = {
	modelId: {
		'en': 432,
		'de': 1489
	},
	propertyPicker2_1: { //
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
	propertyPicker2_2: { // Pen
		componentId: {
			'en': 829,
			'de': 1508
		},
		surfaces: [
			{
				materialId: 1120, // Matt
				surfaceId: {
					'en': 612,
					'de': 1498
				},
				paletteId: {
					'en': 791,
					'de': 1491
				},
				colors: 	{
					1567: 'M02',
					1242: 'M05',
					1243: 'M29',
					1244: 'M66',
					1246: 'M67',
					1840: 'M58',
					1841: 'M62',
					1842: 'M77',
					1843: 'M75',
				}
			},
		],
	},
	propertyPicker3: { // Clip & button
		componentId: {
			'en': 830,
			'de': 1504
		},
		surfaces: [
			{
				materialId: 1186, // Transparent
				surfaceId: {
					'en': 787,
					'de': 1500
				},
				paletteId: {
					'en': 794,
					'de': 1493
				},
				colors: 	{
					1846: 'T66',
					1847: 'T67',
					1844: 'T53',
					1845: 'T62',
				}
			},
			{
				materialId: 1187, // Polished
				surfaceId: {
					'en': 788,
					'de': 1501
				},
				paletteId: {
					'en': 795,
					'de': 1494
				},
				colors: 	{
					1848: 'P02',
					1849: 'P05',
					1850: 'P29',
					1852: 'P77',
					1851: 'P75',
				}
			},
		],
	},
	optionPicker: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
	optionPicker2: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
};

// QS20
mapping['20000'] = {
	modelId: {
		'en': 433,
		'de': 1509
	},
	propertyPicker2_1: { //
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
	propertyPicker2_2: { // Pen
		componentId: {
			'en': 834,
			'de': 1524
		},
		surfaces: [
			{
				materialId: 1120, // Matt
				surfaceId: {
					'en': 613,
					'de': 1518
				},
				paletteId: {
					'en': 792,
					'de': 1511
				},
				colors: 	{
					1567: 'M02',
					1242: 'M05',
					1243: 'M29',
					1244: 'M66',
					1246: 'M67',
					1840: 'M58',
					1841: 'M62',
					1842: 'M77',
					1843: 'M75',
				}
			},
		],
	},
	propertyPicker3: { // Clip & button
		componentId: {
			'en': 836,
			'de': 1525
		},
		surfaces: [
			{
				materialId: 1186, // Transparent
				surfaceId: {
					'en': 789,
					'de': 1519
				},
				paletteId: {
					'en': 796,
					'de': 1512
				},
				colors: 	{
					1846: 'T66',
					1847: 'T67',
					1844: 'T53',
					1845: 'T62',
				}
			},
			{
				materialId: 1187, // Polished
				surfaceId: {
					'en': 790,
					'de': 1520
				},
				paletteId: {
					'en': 797,
					'de': 1513
				},
				colors: 	{
					1848: 'P02',
					1849: 'P05',
					1850: 'P29',
					1852: 'P77',
					1851: 'P75',
				}
			},
		],
	},
	optionPicker: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
	optionPicker2: {
		componentId: {
			'en': '',
			'de': ''
		},
		surfaces: [],
	},
};


var oldProductIds = [1100, 2325, 1128, 1430, 1432, 1433, 49413, 50000, 25342, 1000, 20000];